<template>
  <div class="field">
    <label class="label">Work Entails</label>
      <div class="control mb-2" v-for="(workEntail, index) in workEntails" :key="'work-entail-' + index">
        <input
          v-model="workEntails[index]"
          class="input"
          type="text"
          placeholder="..."
          name="work_entails"
          @input="$emit('input', workEntails.join('@@@'))"
          @focusout="handleChange"
        >
      </div>
  </div>
</template>

<script>
export default {
  name: 'PositionWorkEntails',
  props: {
    value: {
      type: [String],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  computed: {
    workEntails () {
      const ensureAtLeastFourElements = array => array.concat(Array(Math.max(4 - array.length, 0)).fill(''))
      return ensureAtLeastFourElements(this.value.split('@@@'))
    }
  },
  methods: {
    async handleChange () {
      try {
        const data = this.workEntails.filter(workEntail => workEntail.length > 0).join('@@@')
        await this.$network_utils.postText({
          designator: 'work_entails',
          content: data,
          current_resource_id: this.positionId,
          current_type: 'Position'
        })
        await this.$network_utils.updatePosition({ position_id: this.positionId, active_at: new Date() })
        this.$emit('input', data)
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
